<template>
    <div class="empty-state-wrapper">
        <infobox-generic
        state="negative"
        :label="t('transfers.international.prerequisitesNotMet.infoLabel')"
        :content="t('transfers.international.prerequisitesNotMet.infoContent')"/>
        <!-- Illustration -->
        <transfer-illustration class="illustration"/>
        <!-- Title -->
		<div class="title">{{t('transfers.international.prerequisitesNotMet.title')}}</div>
        <!-- SubTitle -->
        <div class="sub-title">{{t('transfers.international.prerequisitesNotMet.subtitle')}}</div>
        <!-- Topics -->
        <div
		v-for="(item, index) in parsedList"
		:key="`item-${index}`"
		class="topic-list"
        :style="{'margin-bottom': index < (parsedList.length - 1) ? '8px' : '0'}">
			<span class="circle"/>
			<div class="list-item" v-html="item.errorMessage"/>
		</div>
        <!-- Message -->
        <div class="message">{{t('transfers.international.prerequisitesNotMet.message')}}</div>
        <!-- Button -->
        <button-secondary
        buttonSize="medium"
        :icon="'pin-drop'"
        :label="t('transfers.international.prerequisitesNotMet.buttonLabel')"
        @clicked="navigateByName(routeList.AGENCIES_NAME)"/>
    </div>
</template>

<script setup>
import InfoboxGeneric from '@/components/generic/infobox/Generic'
import TransferIllustration from '@/assets/icons/illustrations/transfers-international.svg?inline'
import ButtonSecondary from '@/components/generic/buttons/Secondary'

/* Vue */
import { computed } from 'vue'
import { navigateByName } from '@/router/helpers/navigation'
import { routeList } from '@/router/helpers/routes'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** Props received
@missingPrerequisites {Array, Object} - Array or Object which we will iterate to create our bullet list
*/
const props = defineProps({
    missingPrerequisites: [Array, Object]
})

const parsedList = computed(() => {
    if (Array.isArray(props.missingPrerequisites)) return props.missingPrerequisites
    return Object.values(props.missingPrerequisites)
})

</script>

<style lang="scss" scoped>
.empty-state-wrapper {
    width: 100%;
    padding: 16px 0;

    display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;

    :deep(.infobox-generic-wrapper) {
        .information-content {
            text-align: left;
        }
    }

    .illustration {
        width: 100%;

        svg {
            width: 144px;
            height: 144px;

            flex-shrink: 0;
        }
	}

    .title {
        width: 100%;

        @include H3-Medium;
        text-align: center;
        line-height: 28px;
        color: var(--secondary-dark-2);
    }

    .sub-title {
        width: 100%;
        margin: 16px 0;

        @include H5-Medium;
        text-align: left;
        line-height: 16px;
        color: var(--secondary-dark-2);
    }

    .topic-list {
        width: 100%;
        margin-bottom: 8px;

        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        @include H7-Regular;
        text-align: left;
        line-height: 16px;
        color: var(--secondary-dark-2);

        .circle {
            width: 4px;
            height: 4px;
            margin: 8px 8px 0 0;

            flex-shrink: 0;

            border-radius: 50%;
            background-color: var(--secondary-dark-2);
        }
    }

    .message {
        width: 100%;
        margin: 16px 0;

        @include H7-Medium;
        text-align: left;
        line-height: 16px;
        color: var(--secondary-dark-2);
    }
}
</style>
